/* eslint-disable max-len */
import Vue from 'vue';

export default {
  ADD_PLANILHA(state, payload) {
    const { planilha, colunas, colunasExportar } = payload;
    Vue.set(state.planilhas, planilha, {
      colunas,
      colunasExportar,
    });
  },
  ADD_COLUNA_EXPORTAR(state, payload) {
    const { planilha, coluna } = payload;
    state.planilhas[planilha].colunasExportar.push(coluna);
  },
  REMOVE_COLUNA_EXPORTAR(state, payload) {
    const { planilha, coluna } = payload;
    const index = state.planilhas[planilha].colunasExportar.findIndex((_coluna) => _coluna.label === coluna.label);
    Vue.delete(state.planilhas[planilha].colunasExportar, index);
  },
  ADD_COLUNA(state, payload) {
    const { planilha, coluna } = payload;
    state.planilhas[planilha].colunas.push(coluna);
  },
  REMOVE_COLUNA(state, payload) {
    const { planilha, coluna } = payload;
    const index = state.planilhas[planilha].colunas.findIndex((_coluna) => _coluna.label === coluna.label);
    Vue.delete(state.planilhas[planilha].colunas, index);
  },
  ADD_TODOS_EXPORTAR(state, payload) {
    const { planilha } = payload;
    state.planilhas[planilha].colunasExportar = [
      ...state.planilhas[planilha].colunasExportar,
      ...state.planilhas[planilha].colunas,
    ];
  },
  REMOVE_TODOS_EXPORTAR(state, payload) {
    const { planilha } = payload;
    state.planilhas[planilha].colunasExportar = [];
  },
  ADD_TODOS(state, payload) {
    const { planilha } = payload;
    state.planilhas[planilha].colunas = [
      ...state.planilhas[planilha].colunasExportar,
      ...state.planilhas[planilha].colunas,
    ];
  },
  REMOVE_TODOS(state, payload) {
    const { planilha } = payload;
    state.planilhas[planilha].colunas = [];
  },
};
